import React from 'react';
import { Paper, Typography, Grid, Box, Chip } from '@mui/material';
import DatatEod from '../../Models/DataEod';

interface Props { data: DatatEod[]; compact?: boolean; }

export const StatisticsCards: React.FC<Props> = ({ data, compact }) => {
  const total = data.length;
  const opened = data.filter(d => d.cdetat === '50').length;
  const closed = data.filter(d => d.cdetat === '51' || d.cdetat === '53').length;

  const litiges = data.filter(d => 
    Number(d.nbrLitigeNonVal) > 0 || 
    Number(d.nbrLitigeNonConf) > 0 || 
    Number(d.nbrRefEquiNonValEcpT) > 0 || 
    Number(d.nbrRefDeseqNonValEcpT) > 0
  ).length;

  const stats = [
    { label: 'Total', value: total, color: '#1967ba' },
    { label: 'Ouvertes', value: opened, color: '#2e7d32' },
    { label: 'Fermées', value: closed, color: '#d32f2f' },
    { label: 'Attente', value: litiges, color: '#ed6c02' },
  ];

  if (compact) {
    return (
      <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', justifyContent: 'flex-end' }}>
        {stats.map((stat, i) => (
          <Chip
            key={i}
            size="small"
            label={`${stat.label}: ${stat.value}`}
            sx={{ 
              bgcolor: `${stat.color}15`, 
              color: stat.color, 
              fontWeight: 600,
              fontSize: '0.75rem',
              borderLeft: `3px solid ${stat.color}`
            }}
          />
        ))}
      </Box>
    );
  }

  return (
    <Grid container spacing={1}>
      {stats.map((stat, i) => (
        <Grid item xs={6} sm={3} key={i}>
          <Paper elevation={1} sx={{ p: 1, display: 'flex', flexDirection: 'column', borderLeft: `4px solid ${stat.color}` }}>
            <Typography variant="caption" color="textSecondary" sx={{ fontSize: 11 }}>{stat.label}</Typography>
            <Typography variant="h6" sx={{ color: stat.color, fontWeight: 'bold', lineHeight: 1.2 }}>{stat.value}</Typography>
          </Paper>
        </Grid>
      ))}
    </Grid>
  );
};